<template>
  <div class="page-box">
    <!-- 头部 -->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />

    <!-- 内容区域 -->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > 医疗安全不良事件改进专项行动（向错误学习）</div>
        <div class="recruitment-box">
          <div class="recruitment-title">医疗安全不良事件改进专项行动（向错误学习）</div>
          <!-- 表单 -->
          <el-form v-if="!formSubmitted" :model="form" ref="formRef" :rules="rules" label-position="top">
            <div v-for="(item, index) in sentinelHospital" :key="index">
              <el-form-item v-if="item.type == 'ssqselect'" :label="(index + 1) + '. ' + item.title" :prop="item.field">
                <el-cascader v-model="form[item.field]" :options="cityList" :props="{ value: 'label' }"></el-cascader>
              </el-form-item>

              <el-form-item v-if="item.type == 'text'" :label="(index + 1) + '. ' + item.title" :prop="item.field">
                <el-input v-model="form[item.field]" placeholder="请输入" :maxlength="item.maxLength" />
              </el-form-item>

              <el-form-item v-if="item.type == 'radio'" :label="(index + 1) + '. ' + item.title" :prop="item.field">
                <el-select v-model="form[item.field]" placeholder="请选择">
                  <el-option v-for="(itemTwo, indexTwo) in item.options" :key="indexTwo" :label="itemTwo"
                    :value="itemTwo" />
                </el-select>
              </el-form-item>

              <el-form-item v-if="item.type == 'textarea'" :label="(index + 1) + '. ' + item.title" :prop="item.field">
                <el-input v-model="form[item.field]" type="textarea" resize="none" :rows="3" placeholder="请输入"
                  :maxlength="item.maxLength" />
              </el-form-item>

              <el-form-item v-if="item.type == 'file'" :label="(index + 1) + '. ' + item.title" :prop="item.field">
                <div class="hint-text-box">支持word、pdf、ppt等文件上传</div>
                <el-upload 
                  class="avatar-uploader" 
                  action=""
                  :file-list="form[item.field]"
                  :before-upload="(file) => beforeAvatarUpload(file, item)"
                  :http-request="(file) => handleUpload(file, item.field)"
                  list-type="text"
                  :show-file-list="false"
                >
                  <div class="uploading-img-box">
                    <img class="uploading-img" src="@/assets/images/uploading_img.png" alt=""></img>
                    <div class="uploading-text">上传文件</div>
                  </div>
                </el-upload>
                
                <!-- 进度条显示 -->
                <div v-if="uploadProgress[item.field] && uploadProgress[item.field].length > 0" class="upload-progress-container">
                  <div v-for="(progressItem, progressIndex) in uploadProgress[item.field]" :key="progressItem.fileId" 
                       v-if="progressItem.show" class="upload-progress-box">
                    <div class="progress-info">
                      <span class="progress-text">{{ progressItem.fileName }}</span>
                      <span class="progress-percent">{{ progressItem.percent }}%</span>
                    </div>
                    <el-progress 
                      :percentage="progressItem.percent" 
                      :stroke-width="6"
                      class="upload-progress"
                    ></el-progress>
                  </div>
                </div>
                
                <div class="file-line-box">
                  <div class="file-line" v-for="(itemTwo, indexTwo) in form[item.field]" :key="indexTwo">
                    <div class="file-line-left">
                      <img v-if="showFileImg(itemTwo.name, ['doc', 'docx'])" class="file-line-img" src="@/assets/images/word_img.png" alt="" />
                      <img v-if="showFileImg(itemTwo.name, ['pdf'])" class="file-line-img" src="@/assets/images/pdf_img.png" alt="" />
                      <img v-if="showFileImg(itemTwo.name, ['ppt', 'pptx'])" class="file-line-img" src="@/assets/images/ppt_img.png" alt="" />
                      <div class="file-line-text">{{ itemTwo.name }}</div>
                    </div>
                    <div class="file-line-right" @click="onClickDel(indexTwo, item.field)">
                      <i class="el-icon-close"></i>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
            <el-form-item style="text-align: center;">
              <el-button class="bt" type="primary" @click="submitForm">提交</el-button>
            </el-form-item>
          </el-form>
          <img v-else src="@/assets/images/ok.png" style="margin: 50px auto; display: block;" />
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <footer-bar />
  </div>
</template>

<script>
// 修改导入方式，使用更兼容的语法
import ObsClient from "esdk-obs-browserjs/src/obs";
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import { getMedicalSafety, addMedicalSafety, getOBS } from '@/api/home'
const provinces = require('@/assets/address.json');

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav },
  data() {
    return {
      formSubmitted: false,
      selectedIndex: null,
      form: {},
      rules: {},
      sentinelHospital: [], // 题目列表
      cityList: [],
      imageUrl: '',
      obsInfo: {},
      hwClient: null,
      bucket: "ent-zk", //  OBS Bucket 名称
      key: "", // 文件在 OBS 中的路径
      progress: 0,
      uploadCheckpoint: null, // 断点续传记录对象
      uploadProgress: {}, // 上传进度对象，用于存储每个字段的上传进度，结构为 { field: [{ fileName, percent, status, show, fileId }] }
    };
  },
  methods: {
    // 获取有效的进度条状态
    getProgressStatus(status) {
      const validStatuses = ['success', 'exception', 'warning'];
      return validStatuses.includes(status) ? status : '';
    },
    // 更新进度项
    updateProgressItem(field, fileId, percent, status) {
      if (this.uploadProgress[field]) {
        const item = this.uploadProgress[field].find(p => p.fileId === fileId);
        if (item) {
          if (percent !== null) {
            item.percent = percent;
          }
          if (status) {
            item.status = status;
          }
        }
      }
    },
    // 隐藏进度项
    hideProgressItem(field, fileId) {
      if (this.uploadProgress[field]) {
        const item = this.uploadProgress[field].find(p => p.fileId === fileId);
        if (item) {
          item.show = false;
        }
      }
    },
    // 获取总文件数量（包括已上传的和正在上传中的）
    getTotalFileCount(field) {
      const uploadedCount = this.form[field] ? this.form[field].length : 0;
      const uploadingCount = this.uploadProgress[field] ? this.uploadProgress[field].filter(p => p.show).length : 0;
      return uploadedCount + uploadingCount;
    },
    onClickDel(index, name) {
      this.form[name].splice(index, 1)
    },
    showFileImg(name, type) {
      return type.indexOf(name.split('.')[name.split('.').length - 1]) != -1
    },
    beforeAvatarUpload(file, item) {
      // 检查文件数量限制（最多5个文件，包括正在上传中的文件）
      const totalFileCount = this.getTotalFileCount(item.field);
      if (totalFileCount >= item.maxLength) {
        this.$message.error(`最多只能上传${item.maxLength}个文件!`);
        return false;
      }

      // 获取文件扩展名
      const fileName = file.name.toLowerCase();
      const fileExtension = fileName.split('.').pop();
      
      // 允许的文件类型
      const allowedTypes = ['doc', 'docx', 'pdf', 'ppt', 'pptx'];
      const isAllowedType = allowedTypes.includes(fileExtension);
      
      // 文件大小限制（50MB）
      const isLt50M = file.size / 1024 / 1024 < 50;

      if (!isAllowedType) {
        this.$message.error('只能上传 Word、PDF、PPT 格式的文件!');
        return false;
      }
      if (!isLt50M) {
        this.$message.error('文件大小不能超过 50MB!');
        return false;
      }
      return true;
    },
    // 自定义上传逻辑
    handleUpload(file, field) {
      // 再次检查文件数量限制（防止用户快速选择多个文件）
      const totalFileCount = this.getTotalFileCount(field);
      const fieldItem = this.sentinelHospital.find(item => item.field === field);
      const maxLength = fieldItem ? fieldItem.maxLength : 5;
      
      if (totalFileCount >= maxLength) {
        this.$message.error(`最多只能上传${maxLength}个文件!`);
        return;
      }
      
      this.progress = 0;
      
      // 生成唯一的文件ID
      const fileId = Date.now() + Math.random();
      
      // 初始化进度条状态
      if (!this.uploadProgress[field]) {
        this.$set(this.uploadProgress, field, []);
      }
      
      const progressItem = {
        fileId: fileId,
        show: true,
        fileName: file.file.name,
        percent: 0,
        status: ''
      };
      
      this.uploadProgress[field].push(progressItem);

      this.key = `MedicalSafetyCaseFileDTO/${file.file.name}`;

      this.uploadFileWithCheckpoint(file.file, field, fileId);
    },
    uploadFileWithCheckpoint(file, field, fileId) {
      const uploadParams = {
        Bucket: this.bucket,
        Key: this.key,
        SourceFile: file,
        PartSize: 5 * 1024 * 1024, // 分段大小为 5MB
        ProgressCallback: (transferredAmount, totalAmount, totalSeconds) => {
          this.progress = Math.round((transferredAmount / totalAmount) * 100);
          // 更新进度条
          this.updateProgressItem(field, fileId, this.progress);
          console.log(`已上传: ${transferredAmount} 字节, 总大小: ${totalAmount} 字节`);
        },
        EventCallback: (eventType, eventParam, eventResult) => {
          // 处理事件响应
          console.log(`事件类型: ${eventType}, 事件参数: ${eventParam}, 事件结果: ${eventResult}`);
        },
        ResumeCallback: (resumeHook, uploadCheckpoint) => {
          // 获取断点续传控制参数和断点续传记录对象
          this.uploadCheckpoint = uploadCheckpoint;
          console.log("断点续传记录对象:", uploadCheckpoint);
        },
      };

      this.hwClient.uploadFile(uploadParams, (err, result) => {
        if (err) {
          console.error("上传错误:", err);
          // 更新进度条状态为错误
          this.updateProgressItem(field, fileId, null, 'exception');
          // 出现错误，再次调用断点续传接口，继续上传任务
          this.resumeUpload(field, fileId);
        } else {
          console.log("上传成功:", result);
          this.progress = 100; // 设置进度为100%
          // 更新进度条状态为成功
          this.updateProgressItem(field, fileId, 100, 'success');
          // 上传成功后，将文件信息保存到本地
          const fileInfo = {
            url: `https://obs-eye.fduentigo.com/${this.key}`,
            name: file.name,
            uname: file.name,
          };
          console.log("文件信息:", fileInfo);
          this.form[field].push(fileInfo)
          this.$emit('success', fileInfo)
          console.log("文件列表:", this.form[field]);
          
          // 延迟隐藏进度条
          setTimeout(() => {
            this.hideProgressItem(field, fileId);
          }, 2000);
        }
      });
    },
    resumeUpload(field, fileId) {
      if (this.uploadCheckpoint) {
        const resumeParams = {
          UploadCheckpoint: this.uploadCheckpoint,
          ProgressCallback: (transferredAmount, totalAmount, totalSeconds) => {
            this.progress = Math.round((transferredAmount / totalAmount) * 100);
            // 更新进度条
            this.updateProgressItem(field, fileId, this.progress);
            console.log(`已上传: ${transferredAmount} 字节, 总大小: ${totalAmount} 字节`);
          },
          EventCallback: (eventType, eventParam, eventResult) => {
            // 处理事件响应
            console.log(`事件类型: ${eventType}, 事件参数: ${eventParam}, 事件结果: ${eventResult}`);
          },
        };

        this.hwClient.uploadFile(resumeParams, (err, result) => {
          if (err) {
            console.error("断点续传错误:", err);
            // 更新进度条状态为错误
            this.updateProgressItem(field, fileId, null, 'exception');
          } else {
            console.log("断点续传成功:", result);
            this.progress = 100; // 设置进度为100%
            // 更新进度条状态为成功
            this.updateProgressItem(field, fileId, 100, 'success');
            // 延迟隐藏进度条
            setTimeout(() => {
              this.hideProgressItem(field, fileId);
            }, 2000);
          }
        });
      }
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.addMedicalSafety()
        } else {
          this.$message.error("请完善表单内容！");
          return false;
        }
      });
    },
    // 医疗安全不良事件专项行动问题列表
    getMedicalSafety() {
      getMedicalSafety().then(res => {
        console.log(res.data, "getMedicalSafety")
        for (let i = 0; i < res.data.length; i++) {
          if(res.data[i].type == "file") {
            this.$set(this.form, res.data[i].field, [])
          }else {
            this.$set(this.form, res.data[i].field, '')
          }
          this.$set(this.rules, res.data[i].field, [{
            required: true,
            message: res.data[i].type == 'text' ? `请输入${res.data[i].title}` : `请选择${res.data[i].title}`,
            trigger: res.data[i].type == 'text' ? 'blur' : 'change'
          }])
        }
        this.$nextTick(() => {
          this.sentinelHospital = res.data
        })
      })
    },
    // 新增医疗安全不良事件专项行动
    addMedicalSafety() {
      let data = JSON.parse(JSON.stringify(this.form))
      if (data.region) {
        data.region = data.region.join(' ')
      }
      addMedicalSafety(data).then(res => {
        if(res.code == "A00000") {
          this.$message.success("提交成功！");
          this.formSubmitted = true;
        }
      })
    },
    // 获取obs配置信息
    getOBS() {
      getOBS().then(res => {
        this.obsInfo = res.data[0]
        this.hwClient = new ObsClient({
          access_key_id: this.obsInfo.accessKeyId,
          secret_access_key: this.obsInfo.secretAccessKey,
          server: this.obsInfo.endpoint,
          security_token: this.obsInfo.securityToken
        });
        this.bucket = this.obsInfo.bucketName;
      })
    },
    getCityListTree() {
      this.cityList = provinces.provinces
    },
  },
  mounted() {
    this.getOBS()
    this.getCityListTree()
    this.getMedicalSafety()
  },
};
</script>


<style lang="less" scoped>
.hint-text-box {
  color: #999999;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 12px;
}

.avatar-uploader {
  /deep/.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100px;
    height: 100px;
    box-sizing: border-box;
  }
  
  .uploading-img-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;

    .uploading-img {
      width: 29px;
      height: 29px;
      vertical-align: bottom;
      margin-bottom: 6px;
    }

    .uploading-text {
      color: #999999;
      line-height: 12px;
      font-size: 12px;
    }
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 99px;
    height: 99px;
    line-height: 99px;
    text-align: center;
  }

  .avatar {
    width: 99px;
    height: 99px;
    display: block;
  }
}

.file-line-box {
  .file-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    .file-line-left {
      display: flex;
      align-items: center;
      flex: 1;
      overflow: hidden;

      .file-line-text {
        color: #333333;
        font-size: 14px;
        line-height: 24px;
      }

      .file-line-img {
        width: 32px;
        height: 32px;
        vertical-align: bottom;
        margin-right: 8px;
      }
    }

    .file-line-right {
      font-size: 16px;
      cursor: pointer;
    }
  }
}

.qualityControl-box {
  padding-bottom: 20px;
}

.recruitment-box {
  background: #fff;
  text-align: left;
  border-radius: 6px;
  margin-top: 25px;
  padding: 40px 50px 10px 50px;

  /deep/.el-select {
    width: 100%;
  }

  /deep/.el-cascader {
    width: 100%;
  }
}

.recruitment-title {
  color: #A41218;
  font-size: 32px;
  font-weight: bold;
  line-height: 32px;
  margin-bottom: 25px;
  text-align: center;
}

.bt {
  background: linear-gradient(151.62deg, #EF4034 17.54%, #D82E35 117.32%);
  color: #fff;
  font-size: 16px;
  height: 44px;
  border-radius: 50px;
  width: 255px;
  border: none;
  margin-top: 30px;
}

.upload-progress-container {
  margin-top: 12px;
}

.upload-progress-box {
  margin-bottom: 8px;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;

  .progress-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;

    .progress-text {
      color: #333333;
      font-size: 14px;
      font-weight: 500;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 12px;
    }

    .progress-percent {
      color: #666666;
      font-size: 12px;
      font-weight: 500;
      min-width: 40px;
      text-align: right;
    }
  }

  .upload-progress {
    // 进度条样式
  }
}

// 全局样式，用于覆盖 Element UI 进度条样式
.upload-progress .el-progress-bar__outer {
  background-color: #e9ecef !important;
  border-radius: 3px !important;
}

.upload-progress .el-progress-bar__inner {
  border-radius: 3px !important;
}

.upload-progress .el-progress__text {
  font-size: 12px !important;
  color: #666666 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Recruitment/index4.vue